import { Measure } from 'services/model/model.service';

export const MARKDOWN_VS_CATEGORY_CODE = 'markdownVsCategory';
const REFERENCE_MARKDOWN_VALUE = 'referenceMarkdownValue';
const REFERENCE_ORIGINAL_MERCHANDISE_VALUE = 'referenceOriginalMerchandiseValue';

export function toMarkdownVsCategoryMeasure(slsMkdRate: Measure): Measure {
  return {
    ...slsMkdRate,
    code: MARKDOWN_VS_CATEGORY_CODE,
    labelId: 'price.kpi.markdownVsCategory',
    getValue: (values?: Record<string, number>) => {
      const referenceOriginalMerchandiseValue = values?.[REFERENCE_ORIGINAL_MERCHANDISE_VALUE] ?? 0;

      if (referenceOriginalMerchandiseValue === 0) {
        return 0;
      }

      const referenceMarkdownRate = (values?.[REFERENCE_MARKDOWN_VALUE] ?? 0) / referenceOriginalMerchandiseValue;

      return slsMkdRate.getValue(values) - referenceMarkdownRate;
    },
  };
}
